(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/charity.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/charity.js');

'use strict';

const {
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  useAtomValue
} = jotai;
const {
  CharityLogo
} = svs.lyckoplatsen.components.page_play.react.components;
const Charity = () => {
  const charity = useAtomValue(charityAtom);
  if (!charity) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-play-charity"
  }, React.createElement("div", {
    className: "charity-header"
  }, "Din plats bidrar till"), React.createElement("div", {
    className: "charity-body"
  }, React.createElement(CharityLogo, null)));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Charity
});

 })(window);